export default __webpack_public_path__ + "static/media/telegram_menu_logo.23a65978.svg";